import { Injectable, inject } from '@angular/core';
import {LorenBaseCrudService} from '../../../../shared/services/loren-base-crud-service/loren-base-crud.service';
import {LorenAssetEndpointsService} from '../loren-asset-endpoints-service/loren-asset-endpoints.service';
import {LorenAssetType} from '../../interfaces/loren-asset-type.interface';

@Injectable({
    providedIn: 'root'
})
export class LorenAssetTypeService extends LorenBaseCrudService<LorenAssetType> {

    constructor() {
        const endpoints = inject(LorenAssetEndpointsService);

        super(endpoints.assetTypes());
    }
}
